import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSignalMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type DeleteSignalMutation = {
  __typename?: 'Mutation';
  deleteSignal: boolean;
};

export const DeleteSignalDocument = gql`
  mutation DeleteSignal($id: UUID!) {
    deleteSignal(id: $id)
  }
`;
export type DeleteSignalMutationFn = Apollo.MutationFunction<
  DeleteSignalMutation,
  DeleteSignalMutationVariables
>;

/**
 * __useDeleteSignalMutation__
 *
 * To run a mutation, you first call `useDeleteSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignalMutation, { data, loading, error }] = useDeleteSignalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSignalMutation,
    DeleteSignalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSignalMutation,
    DeleteSignalMutationVariables
  >(DeleteSignalDocument, options);
}
export type DeleteSignalMutationHookResult = ReturnType<
  typeof useDeleteSignalMutation
>;
export type DeleteSignalMutationResult =
  Apollo.MutationResult<DeleteSignalMutation>;
export type DeleteSignalMutationOptions = Apollo.BaseMutationOptions<
  DeleteSignalMutation,
  DeleteSignalMutationVariables
>;
